











 









const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "DraggableReflectionCard_staticReflections",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "reflectionGroupId",
      "storageKey": null
    }
  ],
  "type": "RetroReflection",
  "abstractKey": null
};

(node ).hash = "ad25af5ead4deac65c2b20bcfba0e699";

export default node;
